import { defineComponent as w, computed as n, useAttrs as g, ref as E, createBlock as u, openBlock as t, unref as c, mergeProps as m, withCtx as p, resolveDynamicComponent as N, toHandlers as V, createElementBlock as i, createCommentVNode as l, createElementVNode as d, normalizeClass as r, renderSlot as o } from "vue";
import { RevButtonBase as z } from "@ds/components/ButtonBase";
import { RevListItemBase as D } from "@ds/components/ListItemBase";
import { useTrackedListeners as H } from "../../composables/useTrackedListeners.js";
import { omit as O } from "../../utils/omit.js";
const F = /* @__PURE__ */ w({
  name: "RevListItemInteractive",
  inheritAttrs: !1,
  __name: "ListItemInteractive",
  props: {
    for: { default: void 0 },
    to: {},
    wrapperAttrs: { default: () => ({}) },
    itemsCenter: { type: Boolean, default: !1 }
  },
  setup(v, { expose: h }) {
    const s = v, { listeners: k } = H(s), a = n(() => O(g(), ["onClick"])), $ = n(() => s.for ? "label" : z), f = E(null);
    function y() {
      const e = f.value;
      Array.isArray(e) || e === null || e.$el && e.$el.focus();
    }
    h({ focus: y });
    const C = n(
      () => s.to || a.value?.href
    );
    return (e, P) => (t(), u(c(D), m(e.wrapperAttrs, { "items-center": e.itemsCenter }), {
      default: p(({
        wrapperClassNames: B,
        prefixClassNames: b,
        descriptionClassNames: A,
        labelClassNames: I,
        suffixClassNames: L,
        mainAreaClassNames: R
      }) => [
        (t(), u(N($.value), m(a.value, {
          ref_key: "item",
          ref: f,
          class: ["focus-visible-outline-inset-hi cursor-pointer rounded-inherit px-24 hover:bg-static-default-min-hover", B],
          for: s.for,
          to: C.value
        }, V(c(k))), {
          default: p(() => [
            e.$slots.prefix ? (t(), i("div", {
              key: 0,
              class: r(b)
            }, [
              o(e.$slots, "prefix")
            ], 2)) : l("", !0),
            d("div", {
              class: r(R)
            }, [
              d("span", {
                class: r(I)
              }, [
                o(e.$slots, "label")
              ], 2),
              e.$slots.description ? (t(), i("span", {
                key: 0,
                class: r(A)
              }, [
                o(e.$slots, "description")
              ], 2)) : l("", !0)
            ], 2),
            e.$slots.suffix ? (t(), i("div", {
              key: 1,
              class: r(["self-center", L])
            }, [
              o(e.$slots, "suffix")
            ], 2)) : l("", !0)
          ]),
          _: 2
        }, 1040, ["class", "for", "to"]))
      ]),
      _: 3
    }, 16, ["items-center"]));
  }
});
export {
  F as default
};
